import Layout, { DocuLayout } from "../../../../src/components/Layout";
import * as React from 'react';
export default {
  Layout,
  DocuLayout,
  React
};